// based on vc-dialog 7.2.1
import DialogWrap from './DialogWrap';
export default DialogWrap;